export enum ISOCountryCode {
  MY = "Malaysia",
  SG = "Singapore",
  ID = "Indonesia",
  TH = "Thailand",
  IN = "India",
  BD = "Bangladesh"
}
